<template>
  <div class="indexHeader" :class="{'active': activeClass}">
    <div class="container">
      <h1>
        <a class="toIndex" href="index.html">
          <img class="activeLogo" src="./images/en_logo.png" alt="logo">
          <img class="logo" src="./images/en_logo_active.png" alt="logo">
        </a>
      </h1>
      <ul :class="otherColor ? 'otherColor' : ''">
        <li :class="item.klassName" v-for="(item, index) in links" :key="index">
          <a :class="item.isCurrent === true ? 'active' : ''" :href="item.href">{{item.title}}</a>
        </li>
      </ul>
      <p><a href="signup.html">注 册</a><a href="userlogin.do">登 录</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'indexHeader',
  props: {
    active: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      links: [
        {title: '首 页', name: 'index', klassName: '', isCurrent: false, href: 'index.html'},
        {title: '产 品', name: 'supply', klassName: '', isCurrent: false, href: 'supply.html'},
        {title: '安 全', name: 'safe', klassName: '', isCurrent: false, href: 'safe.html'},
        {title: '动 态', name: 'news', klassName: '', isCurrent: false, href: 'news.html'},
        {title: '会 员', name: 'services', klassName: '', isCurrent: false, href: 'services.html'},
        {title: '案 例', name: 'case', klassName: '', isCurrent: false, href: 'case.html'},
        {title: '帮 助', name: 'products', klassName: '', isCurrent: false, href: 'products.html'}
      ],
      otherColor: false,
      activeClass: false
    }
  },
  methods: {
    lightCurrent: function (currentTag) {
      this.links.forEach(function (item) {
        if (item.href.split('.')[0] === currentTag) {
          item.isCurrent = true
        }
      })
    }
  },
  created: function () {
    var href = location.href
    var currentTag = href.substr(href.lastIndexOf('/') + 1) || 'index.html'
    if (currentTag === 'index.html') {
      this.otherColor = true
    }
    this.lightCurrent(currentTag.split('.')[0])
  },
  mounted () {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    this.activeClass = scrollTop >= 100
    window.addEventListener('scroll', () => {
      this.activeClass = (document.documentElement.scrollTop || document.body.scrollTop) >= 100
    }, false)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/header/header.vue